module.exports = "<app-redirection [message]=\"redirectMessage\"></app-redirection>"